import * as React from 'react'

import 'react-datepicker/dist/react-datepicker.css'
import ReactDatePicker from 'react-datepicker'

import { addElToArray, removeElFromArray } from '../../../common/array'
import {
  CAPATCHA,
  CHECKBOXES,
  EMAIL,
  FieldDef,
  FILE,
  NUMBER,
  PHONE,
  RADIOS,
  SELECT,
  TEXT,
  TEXT_AREA,
  DATE,
} from '../../fields'
import { Label } from '../ui'
import { FieldDescription } from '../ui/FieldDescription'
import { Capatcha } from './Capatcha'
import { Checkbox } from './Checkbox'
import { FieldContainer } from './FieldContainer'
import { FieldOuterContainer } from './FieldOuterContainer'
import { Input } from './Input'
import { InputFile } from './InputFile'
import { InputNumber } from './InputNumber'
import { InputPhone } from './InputPhone'
import { Radio } from './Radio'
import { Option, Select } from './Select'
import { TextArea } from './TextArea'
import * as moment from 'moment'
import { DATE_FORMAT } from '../../../common/dates'

type SelectValue = string | []

export class Field extends React.Component<
  {
    id: string
    field: FieldDef
    value: string | number | string[] | File
    hasError: boolean
    error?: string
    onChange?: (value: string | number | string[] | File) => void
    onBlur?: () => void
    recapatchaPublicKey?: string
  },
  {}
> {
  recaptchaInstance: Capatcha | null
  public render() {
    const {
      field,
      id,
      value,
      hasError,
      error,
      onChange,
      onBlur,
      recapatchaPublicKey,
    } = this.props
    const { label, isRequied } = field
    console.log(field, value)

    const onChangeSelect = e => {
      let options = e.target.options
      let selectedOptions: string[] = []
      for (let i = 0; i < options.length; i++) {
        if (options[i].selected) {
          selectedOptions.push(options[i].value)
        }
      }
      onChange && onChange(selectedOptions)
    }
    return (
      <FieldOuterContainer>
        <Label label={label} isRequied={isRequied} htmlFor={id} />
        <FieldContainer>
          {field.type === TEXT && (
            <Input
              id={id}
              type="text"
              value={String(value)}
              onChange={e => {
                onBlur && onBlur()
                onChange && onChange(e.currentTarget.value)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === EMAIL && (
            <Input
              id={id}
              type="email"
              value={String(value)}
              onChange={e => {
                onBlur && onBlur()
                onChange && onChange(e.currentTarget.value)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === DATE && (
            <ReactDatePicker
              id={id}
              value={String(value)}
              selected={value ? moment(String(value)) : null}
              dateFormat={'yyyy-mm-dd'}
              customInput={<Input />}
              peekNextMonth={true}
              showMonthDropdown={true}
              showYearDropdown={true}
              dropdownMode="select"
              onChange={e => {
                onBlur && onBlur()
                if (e) {
                  const date = moment(e)
                  if (date) {
                    const formatted = date.format(DATE_FORMAT)

                    onChange && onChange(formatted)
                  }
                } else {
                  onChange && onChange('')
                }
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === NUMBER && (
            <InputNumber
              id={id}
              type="number"
              value={typeof value === 'number' ? value : 0}
              onChange={e => {
                const cv = parseInt(e.currentTarget.value, 10)
                onBlur && onBlur()
                onChange && onChange(isNaN(cv) ? 0 : cv)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === PHONE && (
            <InputPhone
              id={id}
              type="phone"
              value={String(value)}
              onChange={e => {
                const cv = e.currentTarget.value.replace(/[^0-9- +()\s!?]/g, '')
                onBlur && onBlur()
                onChange && onChange(cv)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === TEXT_AREA && (
            <TextArea
              id={id}
              rows={field.rows || 5}
              value={String(value)}
              onChange={e => {
                onChange && onChange(e.currentTarget.value)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}
          {field.type === SELECT && (
            <Select
              id={id}
              onChange={e => {
                onChangeSelect(e)
                // onChange && onChange(e.currentTarget.value)
              }}
              onBlur={e => {
                onBlur && onBlur()
              }}
              value={value as SelectValue}
              multiple={!!field.multiple}
              data-has-error={hasError ? '1' : '0'}
            >
              <Option value={''}>-- wybierz --</Option>
              {field.values &&
                field.values.map((option, oi) => (
                  <Option key={String(oi)} value={option.value}>
                    {option.label}
                  </Option>
                ))}
            </Select>
          )}
          {field.type === CHECKBOXES &&
            (field.values &&
              field.values.map((option, oi) => (
                <Checkbox
                  key={String(oi)}
                  value={option.value}
                  label={option.label}
                  checked={
                    !!field.multiple
                      ? Array.isArray(value)
                        ? value.indexOf(option.value) !== -1
                        : false
                      : value === option.value
                  }
                  onBlur={() => {
                    onBlur && onBlur()
                  }}
                  onChange={(checked: boolean) => {
                    if (onChange) {
                      if (!!field.multiple) {
                        if (Array.isArray(value)) {
                          if (!checked) {
                            onBlur && onBlur()
                            onChange(removeElFromArray(value, option.value))
                          } else {
                            onBlur && onBlur()
                            onChange(addElToArray(value, option.value))
                          }
                        } else {
                          console.error(
                            'to pole powino mieć tablicę jako value ma:',
                            value,
                          )
                        }
                      } else {
                        if (!checked) {
                          onBlur && onBlur()
                          onChange('')
                        } else {
                          onBlur && onBlur()
                          onChange(option.value)
                        }
                      }
                    }
                  }}
                />
              )))}
          {field.type === RADIOS &&
            (field.values &&
              field.values.map((option, oi) => (
                <Radio
                  key={String(oi)}
                  value={option.value}
                  label={option.label}
                  checked={value === option.value}
                  onBlur={() => {
                    onBlur && onBlur()
                  }}
                  onChange={(checked: boolean) => {
                    if (onChange) {
                      onBlur && onBlur()
                      onChange(option.value)
                    }
                  }}
                />
              )))}

          {field.type === FILE && (
            <InputFile
              id={id}
              onChange={currentTarget => {
                var fileInput = currentTarget
                if (fileInput && fileInput.files) {
                  var file = fileInput.files[0]
                  onBlur && onBlur()
                  onChange && onChange(file)
                } else {
                  onBlur && onBlur()
                  onChange && onChange('')
                }
              }}
              label={'Wybierz plik'}
              onBlur={() => {
                onBlur && onBlur()
              }}
              data-has-error={hasError ? '1' : '0'}
            />
          )}

          {field.type === CAPATCHA && (
            <Capatcha
              publicKey={recapatchaPublicKey || ''}
              onChange={(key: string) => {
                onChange && onChange(key)
              }}
              data-has-error={hasError ? '1' : '0'}
              ref={e => (this.recaptchaInstance = e)}
            />
          )}
        </FieldContainer>

        <FieldDescription description={field.description} hasError={false} />

        {hasError && (
          <FieldDescription description={error || ''} hasError={true} />
        )}
      </FieldOuterContainer>
    )
  }
}
